import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { PageHeader, RowsSkeleton } from "@/components/app/kit";
import { TenantForm } from "@/components/platform/TenantForm";
import { useFetch } from "@/hooks/useServerList";
import { api } from "@/lib/api";

const toForm = (t) => ({
  ...t, logo_data: t.logo_data || null, specialties: t.specialties || [],
  legal_representative: { full_name: "", email: "", phone: "", ...t.legal_representative, email: t.legal_representative?.email || "" },
  medical_director: { full_name: "", email: "", phone: "", ...t.medical_director, email: t.medical_director?.email || "" },
  end_date: t.end_date || "", max_users: t.limits?.max_users, max_patients: t.limits?.max_patients ?? "", storage_mb: t.limits?.storage_mb,
});

const FIELDS = ["name", "commercial_name", "logo_data", "establishment_type", "specialties", "country_code", "city", "address", "postal_code", "phone",
  "email", "website", "legal_representative", "medical_director", "legal_form", "registration_number", "tax_id", "professional_id", "currency",
  "language", "timezone", "locale", "plan_code", "start_date", "end_date", "max_users", "max_patients", "storage_mb"];

export default function TenantEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const ref = useFetch("/platform/reference");
  const detail = useFetch(`/platform/tenants/${id}`);
  if (!ref.data || !detail.data) return <RowsSkeleton rows={8} />;
  const t = detail.data.tenant;
  const save = async (payload) => {
    const body = Object.fromEntries(FIELDS.map((k) => [k, payload[k]]));
    await api.put(`/platform/tenants/${id}`, body);
    toast.success("Cabinet mis à jour");
    navigate(`/admin/cabinets/${id}`);
  };
  return (
    <div>
      <PageHeader eyebrow="Modifier le cabinet" title={t.name} subtitle="L'identifiant technique, le sous-domaine et les modules se gèrent séparément." />
      <TenantForm reference={ref.data} initial={toForm(t)} mode="edit" onSubmit={save} />
    </div>
  );
}
